module.exports = __webpack_public_path__ + "static/img/wzry-companyProducts4.b7d4cd61.png";